import { keyframes, styled } from "goober";

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const Skeleton = styled("div")`
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    var(--alpha4) 30%,
    var(--alpha8) 50%,
    var(--alpha4) 70%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 2.5s linear infinite;
`;
